import { EnvironmentProviders, isDevMode, LOCALE_ID, makeEnvironmentProviders } from '@angular/core';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';

import { TranslocoLoaderService } from './service/transloco-loader.service';

export function provideI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: LOCALE_ID,
      useFactory: (translocoService: TranslocoService) => translocoService.getActiveLang(),
      deps: [TranslocoService],
    },
    provideTransloco({
      config: {
        availableLangs: ['en'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoLoaderService,
    }),
  ]);
}
